
export const RealizationCategories = {
	categories: ['private', 'developer', 'public', 'factory']
}
